import { addDays } from 'date-fns';
import { toDatetimeLocalValue } from '../datetime';

export const DEFAULT_JOB_FORM_DATA = {
	name: '',
	description: '',
	customer: '',
	customer_object: null,
	bid_amount: 0,
	bid_expires_at: toDatetimeLocalValue(addDays(new Date(), 14)),
	send_bid: false,
	quote_includes_stripe_fee: false,
	deposit_percent: '',
};
